import type { HealthResponse } from 'core';
import { QueryClient } from '@tanstack/react-query';
import { ApiError, api } from './api';

/**
 * Query keys start with the entity names of the SSE `invalidate` events (core `INVALIDATE_ENTITIES`),
 * e.g. `['movements', filters]`, so `lib/sse.ts` can refresh them.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => {
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
          return failureCount < 2;
        },
      },
      mutations: { retry: false },
    },
  });
}

export const queryClient = createQueryClient();

export const healthQuery = {
  queryKey: ['health'] as const,
  queryFn: () => api.get<HealthResponse>('/health'),
  staleTime: Infinity,
  retry: 1,
};
